import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
} from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { compressImage, createPreview } from "../../helpers/file-helpers";
import { getSize } from "../../helpers";
import config from "../../config";
import clsx from "clsx";
import axios from "axios";
import { useDispatch } from "react-redux";
import { openImage } from "../../redux/app";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      borderStyle: "solid",
      borderWidth: 1,
      marginTop: 16,
      marginBottom: 8,
    },
    inputWrapper: {
      margin: "0 12px",
      display: "block",
    },
    textField: {
      pointerEvents: "none",
      "& .MuiInputBase-root": {
        marginTop: 4,
        "& input": {
          padding: "18.5px 14px",
        },
      },
    },
    empty: {
      "& .MuiInput-underline:before": {
        display: "none",
      },
    },
  })
);
export default function FilePicker(props) {
  const { isImage, multiple, imageOptions, value, onChange, accept, ...other } =
    props;
  const fileInput = useRef(null);
  const [previewFiles, setPreviewFiles] = useState([]);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    const checkPrevFiles = async () => {
      if (!value || (Array.isArray(value) && !value.length)) {
        setPreviewFiles([]);
        return;
      }
      if (typeof (multiple ? value[0] : value) !== "string") return;

      const _previewFiles = await Promise.all(
        (multiple ? value : [value]).map(async (source, idx) => {
          const file = {};
          const res = await axios.head(source);
          if (res?.status === 200) {
            file.size = res.headers["content-length"];
          }
          file.name = source.split("/").reverse()[0];
          const prev = getFilePreview(file);
          if (isImage) prev.src = source;
          return prev;
        })
      );
      setPreviewFiles(_previewFiles);
    };
    checkPrevFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = async (e) => {
    const { files: inputFiles } = e.target;
    if (!inputFiles) return;

    let filesArr = Array.from(inputFiles);
    if (!filesArr.length) return;

    let _previewFiles;

    if (isImage) {
      const arr = await Promise.all(
        filesArr.map(async (file) => {
          // const { src, newFile } = await compressImage(f, imageOptions);
          const src = await createPreview(file);
          return {
            file,
            preview: { src, ...getFilePreview(file) },
          };
          // return {
          //   file: newFile,
          //   preview: { src, ...getFilePreview(newFile) },
          // };
        })
      );
      _previewFiles = arr.map(({ preview }) => preview);
      filesArr = arr.map(({ file }) => file);
    } else {
      _previewFiles = filesArr.map(getFilePreview);
    }

    setPreviewFiles(_previewFiles);
    onChange?.(multiple ? [...(value || []), ...filesArr] : filesArr[0]);
  };
  const removeFile = (index) => {
    if (Array.isArray(value)) {
      const newVal = [...value];
      newVal.splice(index, 1);
      if (onChange) {
        onChange(newVal);
      }
    } else {
      if (onChange) {
        onChange(undefined);
      }
    }
  };
  const renderListItem = (value, index) => {
    let prev;
    if (typeof value === "string") {
      prev = previewFiles.find((p) => p.src === value) || {};
      // if (!prev?.src?.startsWith("http")) {
      // prev.src = config.get("endpoint") + prev.src;
      // }
    } else {
      prev = previewFiles.find(
        (p) =>
          p.size === value.size &&
          p.name === value.name &&
          p.lastModified === value.lastModified
      );
    }
    const openImagePreview = (src) => {
      dispatch(openImage(src));
    };

    if (!prev) return null;

    const size = getSize(prev.size);
    return (
      <ListItem key={prev?.name || prev.src || index} button>
        <ListItemAvatar>
          <Avatar
            alt={prev.name}
            src={prev.src}
            variant="square"
            onClick={() => openImagePreview(prev.src)}
            // variant="rounded"
          />
        </ListItemAvatar>
        <ListItemText
          primary={prev.name}
          secondary={size}
          primaryTypographyProps={{ noWrap: true }}
          secondaryTypographyProps={{ noWrap: true }}
        />
        <ListItemSecondaryAction>
          <IconButton onClick={() => removeFile(index)} edge="end">
            <DeleteIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  const handleFocusInput = () => {
    if (fileInput.current && !props.disabled) {
      fileInput.current.click();
    }
  };
  return (
    <div className={clsx(classes.root, "MuiOutlinedInput-notchedOutline")}>
      <input
        ref={fileInput}
        type="file"
        hidden
        multiple={multiple || true}
        accept={accept || (isImage ? "image/*" : undefined)}
        onChange={handleChange}
      />

      <label className={classes.inputWrapper} onClick={handleFocusInput}>
        <TextField
          className={clsx(classes.textField, {
            [classes.empty]: !previewFiles.length,
          })}
          // onClick={handleFocusInput}
          fullWidth
          label="label"
          inputProps={{
            disabled: true,
            // styles: { pointerEvent: "none" },
          }}
          // variant="outlined"
          {...other}
          margin="none"
        />
      </label>

      {value && previewFiles.length ? (
        <div className="bg-default">
          <List dense>
            {Array.isArray(value)
              ? value.map(renderListItem)
              : renderListItem(value)}
          </List>
        </div>
      ) : null}
    </div>
  );
}
function getFilePreview(file) {
  const { lastModified, name, size } = file;

  return {
    lastModified,
    name,
    size,
    ext: name?.lastIndexOf(".") < 0 ? undefined : name?.split(".").reverse()[0],
  };
}
